import { ChangeDetectorRef, Component, OnInit, SimpleChange, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import {MatCardModule} from '@angular/material/card'; 
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { DetalleTareaService } from './detalle-tareas-service';
import { Tarea } from '../../../models/tareas.model';
import { Observable, Subject, takeUntil } from 'rxjs';
import { CommonModule, JsonPipe } from '@angular/common';
import { FormTypeWidgetComponent } from 'app/modules/GlobalComponents/id-formulario-widget.component';
import {MatTabsModule} from '@angular/material/tabs';
import { TaskInfoComponent } from "./task-info/task-info.component";
import { ArrowBackComponent } from "../../GlobalComponents/arrow-back.component";
import { ActividadesTareaComponent } from './tabs/archivos/actividad/actividad-tarea.component';
import { ComentariosComponent } from "../../SharedEntitiesComponents/cometarios/comentarios";
import { environment } from 'environments/environments';
import { ElementosVinculadosComponent } from 'app/modules/SharedEntitiesComponents/elementos-vinculados/elementos-vinculados';
import { ArchivosSubidosComponent } from 'app/modules/SharedEntitiesComponents/archivos-subidos/archivos-subidos';
import { DetalleSolicitudVaComponent } from "../../SharedEntitiesComponents/detalle-solicitud-va/detalle-solicitud-va";
import { UtilsService } from 'app/modules/utils-service';
import { MatDrawer, MatSidenavModule } from '@angular/material/sidenav';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { ArchivosSubidosInterface } from 'app/models/archivos-subidos-model';
import { VistaArchivoComponent } from "../../SharedEntitiesComponents/preview-document/vista-archivo";
import { ElementosVinculadosInterface } from 'app/models/elementos-vinculados-model';
import { CargarArchivosComponent } from 'app/modules/SharedEntitiesComponents/subir-archivo/cargar-archivos.component';
import { SolicitudesService } from '../solicitudes/solicitudes.service';
import { MatDialog } from '@angular/material/dialog';
import { CompletarGestionComponent } from 'app/modules/SharedEntitiesComponents/modal-completar-gestion/completar-gestion.component';
import { CONSTANTS } from 'app/core/constants';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { CompletarGestionSinAsociarBienComponent } from 'app/modules/SharedEntitiesComponents/completar-getion-sin-asociar-bien/completar-gestion-sin-asociar-bien.component';
import { AlertMessageComponent } from 'app/modules/GlobalComponents/dialog.component';

@Component({
    selector: 'detalle-tarea-component',
    templateUrl: 'detalle-tarea.component.html',
    imports: [
    CommonModule,
    MatSelectModule,
    MatTableModule,
    MatButtonModule,
    MatTabsModule,
    MatCardModule,
    FormsModule,
    MatFormFieldModule,
    MatIconModule,
    MatMenuModule,
    MatMenuModule,

    //components
    FormTypeWidgetComponent,
    TaskInfoComponent,
    ArrowBackComponent,
    ArchivosSubidosComponent,
    ActividadesTareaComponent,
    ComentariosComponent,
    ElementosVinculadosComponent,
    DetalleSolicitudVaComponent,
    MatSidenavModule,
    VistaArchivoComponent,
    CargarArchivosComponent,
]
})


export class DetalleTareaPageComponent implements OnInit {
    TaskDetails: Tarea;
     _unsubscribeAll: Subject<any> =  new Subject<any>();
    tipologiaIdAdmitida:number
    tipologiaIdRechazada:number
    tareaTipoSolicitud: number
    tareaTipoGestion:number= CONSTANTS.ID_TIPO_TAREA_GESTION
    estadoGestionCompletada= CONSTANTS.ID_ESTADO_GESTION_COMPLETADA
    esdatogestionNoCompletada= CONSTANTS.ID_ESTADO_GESTION_NO_COMPLETADA
    mostrarBoton:boolean
    isDrawerOpen$: Observable<boolean>

    archivoSeleccionado:ArchivosSubidosInterface
    elementosVinculados$: Observable<ElementosVinculadosInterface[]>
    linkElementoVinculado:string='/task-details/task'

    //archivoSeleccionado: any = null;
    @ViewChild('matDrawer', { static: false }) matDrawer?: MatDrawer;
    drawerMode: 'side' | 'over';

    estadoTarea : number

    constructor(
        private taskService: DetalleTareaService, 
        private cdRef: ChangeDetectorRef, 
        private utilsService:UtilsService,
        private router:Router,
        private _solicitudesService: SolicitudesService,
        public dialog: MatDialog,
    ) { 
        this.isDrawerOpen$=this.taskService.isDrawerOpen$;
        this.elementosVinculados$= this.taskService.elementosVinculadosTasks$
        
        this.taskService.detalleTarea$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((taskDetails: Tarea) => {
                this.TaskDetails = taskDetails; 
                this.validarMostrarBoton();
                this._solicitudesService.getUsuarios()

                if (this.TaskDetails.tipoTarea.tipologiaId === environment.TIPOLOGIA_ID_SOLICITUDES  ) {
                   this.taskService.getTipologiasEstadoTask(environment.TIPOLOGIA_PADRE_ID_ESTADO_SOLICITUD)
                } else {
                    this.taskService.getTipologiasEstadoTask(environment.TIPOLOGIA_PADRE_ID_ESTADO_GESTIONES)
                }

            });
        
        this.tareaTipoSolicitud= environment.TIPOLOGIA_ID_SOLICITUDES
        this.tipologiaIdAdmitida= environment.TIPOLOGIA_ID_ESTADO_ADMITIDA
        this.tipologiaIdRechazada= environment.TIPOLOGIA_ID_ESTADO_RECHAZADA
    }

    ngOnInit() {this.validarMostrarBoton();}

    validarMostrarBoton(): void {
        this.mostrarBoton =
            this.TaskDetails?.tipoTarea?.tipologiaId === this.tareaTipoSolicitud &&
            this.TaskDetails?.estadoTarea?.tipologiaId != this.tipologiaIdAdmitida &&
            this.TaskDetails?.estadoTarea?.tipologiaId != this.tipologiaIdRechazada;
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    aprobarSolicitud(){

        if(this.TaskDetails.usuariosAsignados.length >0){
            this.utilsService.open_confirm_dialog(`Esta seguro que desea Admitir la solicitud  ${this.TaskDetails.nombreTarea}`, 'Aceptar Solicitud')
            .subscribe(response=>{
                if(response == 'confirmed'){
                    this.taskService.postAprobarSolicitud(this.TaskDetails.tareaUuid)
                    .then((response:any)=>{
                        this.router.navigate(['/task-details/task/', response.data]);
                    })
                }
            }) 
        }else{
            this.utilsService.showErrorMessage('Debe de asignar un usuario antes de admitir la solicitud')
        }
         
    } 

    abrirDrawer(archivo: ArchivosSubidosInterface) {
        this.archivoSeleccionado = archivo;
        this.taskService.openDrawer();
        this.matDrawer.open();
    }
     
    closeDrawer() {
        this.taskService.closeDrawer();
        this.matDrawer.close();
    }

    completarGestion(){
        const dialog = this.dialog.open(CompletarGestionComponent, {
                            panelClass: ['w-full', 'md:w-6/12','mx-0'],
                            maxHeight: 'calc(100vh - 4rem)',
                            disableClose: true,
                            data: this.TaskDetails
                        })
    }

    completarGestionSinAsociarBien(){
        const dialog = this.dialog.open(CompletarGestionSinAsociarBienComponent, {
                            panelClass: ['w-full', 'md:w-6/12','mx-0'],
                            maxHeight: 'calc(100vh - 4rem)',
                            disableClose: true,
                            data: this.TaskDetails
                        })
    }

    duplicarGestion(){
        this.taskService.duplicarGestion(this.TaskDetails.tareaUuid)
        .then((response:any)=>{
            this.router.navigate(['/task-details/task/', response.data]);
        })
    }

    descargarFormularioSolicitud(){
        const url = `/api/v-agil/archivos/formulario/${this.TaskDetails.tareaUuid}`;
        const ref = this.dialog.open(AlertMessageComponent, {
            disableClose: true,
            data: { title: 'Generando formulario…', message: 'Preparando archivo PDF.' }
        });
        this.utilsService.exportFile(url, null, 'pdf', `Formulario-solicitud-${this.TaskDetails.correlativo}`)
            .finally(() => ref.close());
    }

    generarExpediente(){
        const url = `/api/v-agil/archivos/expediente/${this.TaskDetails.tareaUuid}`;
        const ref = this.dialog.open(AlertMessageComponent, {
            disableClose: true,
            data: { title: 'Generando expediente…', message: 'Preparando archivo PDF.' }
        });
        this.utilsService.exportFile(url, null, 'pdf', `Expediente-${this.TaskDetails.correlativo}`)
            .finally(() => ref.close());
    }

    descargarZip(){
        const url = `/api/v-agil/archivos/download_zip/${this.TaskDetails.tareaUuid}`;
        const ref = this.dialog.open(AlertMessageComponent, {
            disableClose: true,
            data: { title: 'Preparando descarga…', message: 'Comprimiendo archivos en ZIP.' }
        });
        this.utilsService.exportFile(url, null, 'zip', `Archivos-solicitud-${this.TaskDetails.correlativo}`)
            .finally(() => ref.close());
    }  

}